export const SET_WPPAGE_SITE = 'pages/set-page-site';
export const SET_WPPAGE_LIST = 'pages/set-page-list';
export const PUSH_WPPAGE_TOLIST = 'pages/push-page-to-list';
export const SET_WPPAGE_SELECTED = 'pages/set-page-selected';
